var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [_vm._v("신고자/피신고자 관리")]),
        _c("ol", { staticClass: "breadcrumb ml-auto" }, [
          _c("li", { staticClass: "breadcrumb-item" }, [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
          ]),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v("\n          게시물 관리\n        ")
          ]),
          _c("li", { staticClass: "breadcrumb-item active" }, [
            _c("a", { attrs: { href: "/community/warnUserList" } }, [
              _vm._v("신고자/피신고자 관리")
            ])
          ])
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "list",
              expression: "data.params.mode=='list'"
            }
          ],
          staticClass: "card card-default"
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "form-row align-items-center" },
              [
                _c("SchDateRange", {
                  attrs: { label: "기간", data: _vm.data },
                  on: { search: _vm.search }
                }),
                _c(
                  "div",
                  {
                    staticClass: "form-group no-margin row",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("div", { staticClass: "col-auto" }, [
                      _c("label", { staticClass: "col-form-label" }, [
                        _vm._v("채널")
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-auto" },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "mt-2 mb-1" },
                          [
                            _c("div", { staticClass: "form-check mb-2" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data.selectAllUserType,
                                    expression: "data.selectAllUserType"
                                  }
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  id: "user-type-all",
                                  value: "",
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.data.selectAllUserType
                                  )
                                    ? _vm._i(_vm.data.selectAllUserType, "") >
                                      -1
                                    : _vm.data.selectAllUserType
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.data.selectAllUserType,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.data,
                                            "selectAllUserType",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.data,
                                            "selectAllUserType",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.data,
                                        "selectAllUserType",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "user-type-all" }
                                },
                                [_vm._v("전체")]
                              )
                            ]),
                            _vm._l(_vm.warnUserTypes.array, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "form-check mb-2 ml-3"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.data.selectedUserTypes,
                                        expression: "data.selectedUserTypes"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      id: "user-type-" + index,
                                      type: "checkbox"
                                    },
                                    domProps: {
                                      value: item.value,
                                      checked: Array.isArray(
                                        _vm.data.selectedUserTypes
                                      )
                                        ? _vm._i(
                                            _vm.data.selectedUserTypes,
                                            item.value
                                          ) > -1
                                        : _vm.data.selectedUserTypes
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.data.selectedUserTypes,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = item.value,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.data,
                                                "selectedUserTypes",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.data,
                                                "selectedUserTypes",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.data,
                                            "selectedUserTypes",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form-check-label",
                                      attrs: { for: "user-type-" + index }
                                    },
                                    [_vm._v(_vm._s(item.text))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c("sch-text", {
                  staticStyle: { width: "100%" },
                  attrs: { label: "검색어", data: _vm.data, includeAll: false },
                  on: { search: _vm.search }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c("div", { staticClass: "card card-default" }, [
        _c(
          "div",
          { staticClass: "card-header mt-2" },
          [
            _c("span", { staticClass: "text-bold h4" }, [_vm._v("목록")]),
            _c("ShowCounter", {
              staticClass: "ml-1",
              attrs: { label: "Show", data: _vm.data },
              on: { search: _vm.search }
            })
          ],
          1
        ),
        _c("div", { staticClass: "card-body" }, [
          _c(
            "table",
            { staticClass: "table table-striped table-bordered table-hover" },
            [
              _c("thead", [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "4%" }
                    },
                    [_vm._v("No")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" },
                      on: {
                        click: function($event) {
                          return _vm.localSort.sort("userId")
                        }
                      }
                    },
                    [
                      _vm._v("아이디"),
                      _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" },
                      on: {
                        click: function($event) {
                          return _vm.localSort.sort("userName")
                        }
                      }
                    },
                    [
                      _vm._v("이름"),
                      _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" }
                    },
                    [_vm._v("회원상태")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" }
                    },
                    [_vm._v("이용채널")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" },
                      on: {
                        click: function($event) {
                          return _vm.localSort.sort("warnPostCount")
                        }
                      }
                    },
                    [
                      _vm._v("게시물 신고횟수"),
                      _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" },
                      on: {
                        click: function($event) {
                          return _vm.localSort.sort("warnCmmtCount")
                        }
                      }
                    },
                    [
                      _vm._v("댓글 신고횟수"),
                      _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" },
                      on: {
                        click: function($event) {
                          return _vm.localSort.sort("completeCount")
                        }
                      }
                    },
                    [
                      _vm._v("처리완료 수"),
                      _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { width: "10%" },
                      on: {
                        click: function($event) {
                          return _vm.localSort.sort("warnDt")
                        }
                      }
                    },
                    [
                      _vm._v("신고일"),
                      _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                    ]
                  )
                ])
              ]),
              _c(
                "tbody",
                [
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.data.count == 0,
                          expression: "data.count==0"
                        }
                      ],
                      staticClass: "text-center"
                    },
                    [
                      _c("td", { attrs: { colspan: "9" } }, [
                        _vm._v("No matching records")
                      ])
                    ]
                  ),
                  _vm._l(_vm.data.list, function(item, index) {
                    return [
                      _c("tr", { key: index }, [
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(
                            _vm._s(
                              _vm.data.params.limit *
                                (_vm.data.params.page - 1) +
                                index +
                                1
                            )
                          )
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(item.maskedUserId))
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(item.userName))
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(item.status))
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(_vm.warnUserTypes.getText(item.typeCd)))
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(item.warnPostCount))
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(item.warnCmmtCount))
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(item.completeCount))
                        ]),
                        _c("td", { staticClass: "align-middle text-center" }, [
                          _vm._v(_vm._s(item.warnDt))
                        ])
                      ])
                    ]
                  })
                ],
                2
              )
            ]
          )
        ]),
        _c("div", { staticClass: "card-footer" }, [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("Pagenation", {
                key: _vm.data.params.page,
                attrs: { data: _vm.data },
                on: {
                  next: function($event) {
                    return _vm.dataAction.next(_vm.search)
                  },
                  prev: function($event) {
                    return _vm.dataAction.prev(_vm.search)
                  },
                  first: function($event) {
                    return _vm.dataAction.first(_vm.search)
                  },
                  last: function($event) {
                    return _vm.dataAction.last(_vm.search)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("loading", {
        attrs: { active: _vm.modalLoading, "is-full-page": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }